<template>
  <section class="community-section marketing-section">
    <div class="marketing-section__content--narrow">
      <h2 class="text-h4 font-weight-bold mb-6">
        Built for RVers who plan with confidence
      </h2>

      <p class="text-body-1 mb-4">
        Turn a good idea into a real rally &mdash; dates, location, and
        expectations locked in so everyone can commit.
      </p>

      <p class="text-body-1 mb-6">
        With threshold funding, the event only moves forward when enough people
        are in. Clear details, shared accountability, and a simple way to
        organize without a middleman.
      </p>

      <blockquote
        class="community-section__quote text-h6 font-italic font-weight-medium mb-6"
      >
        &ldquo;I don't want 'interested' &mdash; I want confirmed. Arvee makes
        it real.&rdquo;
      </blockquote>

      <p class="text-body-1 font-weight-bold text-primary">
        Arvee provides the rails. Your community drives the adventure.
      </p>
    </div>
  </section>
</template>

<style scoped>
.community-section {
  background: var(--arvee-surface-warm);
}

.community-section__quote {
  border-left: 4px solid rgb(var(--v-theme-primary));
  padding-left: 1rem;
}
</style>
